import { FC } from "react"
import React,{useEffect, useState, useMemo } from "react";
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { KTSVG } from "../../../smallnation/helpers"
import services from "../../modules/services/services"
import { Pagination } from "../../modules/utility/Pagination"
import { Link } from 'react-router-dom';
import moment from "moment";
import $ from 'jquery';
//import { TablesWidget10, TablesWidget5,TablesWidget1, TablesWidget2,TablesWidget3,TablesWidget4,TablesWidget6,TablesWidget7,TablesWidget8,TablesWidget9,TablesWidget11,TablesWidget12,TablesWidget13  } from "../../../smallnation/partials/widgets"
//import { ProfileDirectoryInc } from "../../../smallnation/partials/widgets/tables/profileDirectoryInc"


const NotificationList: FC = () => {
      const intl = useIntl()

      const ITEMS_PER_PAGE = 10; // Per page show the data pagination
      const [totalItems, setTotalItems] = useState(0);
      const [totalpages, settotalPages] = useState(0);
      const [currentPage, setCurrentPage] = useState(1);
   
      const [eventList, setEventList] = useState([]);

     const Pagesize=10;

      const siteId = '2';                
      
  useEffect(() => 
      {         
        //getAdminProfilesList(ITEMS_PER_PAGE,'1','','');
        //getEventList(siteId);      
        filterNotificationList(ITEMS_PER_PAGE,'1');

      },[]);

      const searchList = () => {
        filterNotificationList(ITEMS_PER_PAGE,'1'); 
      }

      const filterNotificationList = (ITEMS_PER_PAGE,pageNumber) => {     
     
          var searchTxt:any = $('#search_input').val();
          var encoded_queryval = encodeURIComponent(searchTxt.trim());
        var siteIdIn = "2";
       
        services.getNotificationListbySiteId(siteIdIn,ITEMS_PER_PAGE,pageNumber,encoded_queryval).then((res) => 
        {

          //console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@events widg 113");
            if(res.data.content){
             console.log(JSON.stringify(res.data));
                $(".paginationContent").show();
                setTotalItems(res.data.totalElements);         
                settotalPages(Math.ceil(res.data.totalElements / ITEMS_PER_PAGE));                    
                setCurrentPage(pageNumber);
    
                var contAr = res.data.content;
                //setProfileList(res.content);
                if(res.data.content){
                   setEventList(res.data.content);
                }                
                

           }              

        });
}
      const handlePageChange2 = (offset,triggerevent) => {
        // alert(offset);
        filterNotificationList(ITEMS_PER_PAGE,offset);
      };
      
      
    
      type Props = {
        className: string
      }
      return (
        <>
          <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'Notifications List'})}</PageTitle>
         
        <div className={`card`}>
     
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
        <table className=''>
            <thead>
              <tr className='fw-bolder text-muted pb-3 '>             
                <th  style={{minWidth:"450px"}}><input type="text" id="search_input" name="search_input" className="form-control" placeholder="" onChange={searchList}/> </th>
                <th className='min-w-140px'> <button type="button" onClick={searchList} className="btn btn-primary" style={{maxWidth: "135px"}}> Search </button></th>
              </tr>
            </thead>
            </table>
          {/* begin::Table */}
          <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bolder text-muted'>
               {/* <th className='w-25px'>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      value='1'
                      data-kt-check='true'
                      data-kt-check-target='.widget-13-check'
                    />
                  </div>
                </th> */}
                <th className='min-w-150px'>Title</th>
                <th className='min-w-140px'>Start Date</th>
                <th className='min-w-120px'>End Date</th>            
               
                <th className='min-w-100px text-end'>Actions</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>

            {	
	          eventList.map((data, index) => (
              <tr>
                {/*<td>
                  <div className='form-check form-check-sm form-check-custom form-check-solid'>
                    <input className='form-check-input widget-13-check' type='checkbox' value='1' />
                  </div>
                </td> */}

<td>
                  {/* <a href={`/editNotification?notificationId=`+data.notificationId} className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6'>
{data.notificationTitle}
                  </a> */}

                  <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={`/editNotification?notificationId=`+data.notificationId}>{(data.notificationTitle=='' || data.notificationTitle==null) ? '--' : data.notificationTitle}</Link>
                 
                </td>

                <td>
                  {/* <a href={`/editNotification?notificationId=`+data.notificationId}ssssss className='text-dark fw-bolder text-hover-primary fs-6'>
                  {moment(data.startDate).format("D-MMM-YY")}
                  </a> */}

                  <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={`/editNotification?notificationId=`+data.notificationId}>{(data.startDate=='' || data.startDate==null) ? '--' : moment(data.startDate).format("MM/DD/YYYY")}</Link>
                </td>
               
                <td>
                {/* <a href={`/editNotification?notificationId=`+data.notificationId}ssssss className='text-dark fw-bolder text-hover-primary fs-6'>
                  {moment(data.endDate).format("D-MMM-YY")}
                  </a> */}

                  <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={`/editNotification?notificationId=`+data.notificationId}>{(data.endDate=='' || data.endDate==null) ? '--' : moment(data.endDate).format("MM/DD/YYYY")}</Link>
                 
                </td>
              
            
              
                <td className='text-end'>
                 
                  {/* <a
                    href={`/editNotification?notificationId=`+data.notificationId}
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                  >
                    <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                  </a> */}

                  <Link className='text-dark fw-bolder text-hover-primary d-block mb-1 fs-6' to={`/editNotification?notificationId=`+data.notificationId}><KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' /></Link>
                 
                </td>
              </tr>
              ))}
              
            </tbody>
            {/* end::Table body */}
          </table>

          <Pagination
                
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={handlePageChange2}

                />
         
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>


          
        </>
      )
    }
export {NotificationList}